import { render, staticRenderFns } from "./PanelBar.vue?vue&type=template&id=60fa8020&"
import script from "./PanelBar.vue?vue&type=script&lang=js&"
export * from "./PanelBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports